"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Struct = _interopRequireDefault(require("../codec/Struct"));

var _Bool = _interopRequireDefault(require("../primitive/Bool"));

var _USize = _interopRequireDefault(require("../primitive/USize"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
const JSON_MAP = new Map([['isSyncing', 'is_syncing'], ['shouldHavePeers', 'should_have_peers']]);
/**
 * @name Health
 * @description
 * A system health indicator, reported back over RPC
 */

class Health extends _Struct.default {
  constructor(value) {
    super({
      peers: _USize.default,
      isSyncing: _Bool.default,
      shouldHavePeers: _Bool.default
    }, value, JSON_MAP);
  }
  /**
   * @description The sync status
   */


  get isSyncing() {
    return this.get('isSyncing');
  }
  /**
   * @description The numbers of peers as [[U32]]
   */


  get peers() {
    return this.get('peers');
  }
  /**
   * @description Should this node have peers (not active on --dev)
   */


  get shouldHavePeers() {
    return this.get('shouldHavePeers');
  }

}

exports.default = Health;